"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _createIconComponent = _interopRequireDefault(require("../utils/createIconComponent"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const PreviewLocationIcon = (0, _createIconComponent.default)({
  content: ( /*#__PURE__*/_react.default.createElement("g", null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.001 1c3.386 0 5.306 2.919 4.59 6.022C12.082 9.232 9.002 15 8.002 15c-.935 0-4.072-5.77-4.59-7.978C2.691 3.949 4.596 1 8.001 1zM8 7.396a1.77 1.77 0 100-3.54 1.77 1.77 0 000 3.54z"
  })))
});
PreviewLocationIcon.displayName = 'PreviewLocationIcon';
var _default = exports.default = PreviewLocationIcon;